import { HttpResponse, HttpParams } from "@angular/common/http";
import { Pagination } from "../../models/pagination.model";
import { Subscription } from "rxjs";
import { EntityListRefresh } from "../../services/entity-list.refresh";
import { IFetchList } from "../../services/fetch-entity.interface";
import { ProgressBarService } from "../../services/progress-bar.service";
import { ICriteria } from "../../services/criteria.interface";
import { SortItem } from "../../models/sort-item.model";

export abstract class EntityDatatableComponent<TList, TCriteria extends ICriteria, TService extends IFetchList> {
  entityList: TList[] = [];
  pagination: Pagination;
  refreshSubscription: Subscription;
  sortItems: SortItem[] = [];

  constructor(
    protected entityName: string,
    public criteria: TCriteria,
    protected entityListRefresh: EntityListRefresh,
    protected entityService: TService,
    protected progressBarService: ProgressBarService
  ) {
  }

  initData(data: HttpResponse<TList[]>) {
    this.pagination = <Pagination>JSON.parse(data.headers.get('x-pagination'));
    this.entityList = <TList[]>data.body;

    this.refreshSubscription = this.entityListRefresh.refresh$.subscribe((entityName: string) => {
      if (this.entityName === entityName) {
        this.reloadData();
      }
    });
  }

  destroyData() {
    // prevent memory leak when component destroyed
    this.refreshSubscription.unsubscribe();
  }

  reloadData() {
    this.progressBarService.start();
    this.entityService.get(this.criteria.paramsExport())
      .subscribe((response: HttpResponse<TList[]>) => {
        this.pagination = <Pagination>JSON.parse(response.headers.get('x-pagination'));
        this.entityList = <TList[]>response.body;
        this.progressBarService.end();
      });
  }

  prevPage() {
    this.criteria.page = this.pagination.page - 1;
    this.reloadData();
  }

  nextPage() {
    this.criteria.page = this.pagination.page + 1;
    this.reloadData();
  }

  goToPage(page: number) {
    this.criteria.page = page;
    this.reloadData();
  }

  onSort(sortTerm: string) {
    this.criteria.orderby = sortTerm;
    this.reloadData();
  }
}
